import React, { useState, useEffect, useRef } from 'react';

// Simple Native Ad Container
const NativeAdContainer = ({ nativeCode }) => {
  const containerRef = useRef(null);
  
  useEffect(() => {
    if (nativeCode && containerRef.current) {
      try {
        containerRef.current.innerHTML = nativeCode;
        console.log('Native ad injected');
      } catch (error) {
        console.error('Error loading native ad:', error);
      }
    }
  }, [nativeCode]);
  
  return (
    <div className="w-full flex justify-center py-4">
      <div 
        ref={containerRef}
        className="native-ad-container"
        style={{ display: 'inline-block', textAlign: 'center' }}
      />
    </div>
  );
};

const NativeAdSection = () => {
  const [nativeAd, setNativeAd] = useState(null);
  const [loading, setLoading] = useState(true);

  const API = process.env.REACT_APP_BACKEND_URL;

  useEffect(() => {
    fetchNativeAd();
  }, []);

  const fetchNativeAd = async () => {
    try {
      const response = await fetch(`${API}/api/public/native-ad/global_native_bottom`);
      if (response.ok) {
        const adData = await response.json();
        
        console.log('Native ad data received:', adData);
        
        if (adData && !adData.error) {
          setNativeAd(adData);
        }
      }
    } catch (error) {
      console.error('Error fetching native ad:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleAdClick = async (adId, clickUrl) => {
    try {
      // Track the click
      await fetch(`${API}/api/ads/${adId}/click`, { method: 'POST' });
      
      // Open the click URL
      if (clickUrl) {
        window.open(clickUrl, '_blank');
      }
    } catch (error) {
      console.error('Error tracking ad click:', error);
    }
  };

  if (loading) {
    return (
      <div className="native-ad-section bg-gray-800 border-t border-gray-700 mt-12 py-8">
        <div className="w-full">
          <div className="flex justify-center">
            <div className="animate-pulse bg-gray-700 h-24 w-full max-w-md rounded"></div>
          </div>
        </div>
      </div>
    );
  }

  if (!nativeAd) {
    // Return minimal or no placeholder when no ad is configured
    return (
      <div className="native-ad-section mt-12">
        <div className="w-full text-center">
          <div className="text-xs text-gray-500 opacity-50">
            {/* Native ad space - currently empty */}
          </div>
        </div>
      </div>
    );
  }

  // If there's native_code, render it in container
  if (nativeAd.native_code) {
    return (
      <div className="native-ad-section mt-12">
        <div className="w-full">
          <NativeAdContainer nativeCode={nativeAd.native_code} />
        </div>
      </div>
    );
  }

  return (
    <div className="native-ad-section mt-12">
      <div className="w-full">
        <div className="flex justify-center">
          <div 
            className="inline-block bg-gray-700 rounded-lg p-4 cursor-pointer hover:bg-gray-600 transition-colors"
            onClick={() => handleAdClick(nativeAd.id, nativeAd.click_url)}
          >
            <div className="flex items-center space-x-4">
              {nativeAd.image_url && (
                <img 
                  src={nativeAd.image_url} 
                  alt={nativeAd.title}
                  className="w-16 h-16 object-cover rounded"
                  onError={(e) => {e.target.style.display = 'none'}}
                />
              )}
              
              <div className="flex-1 text-left">
                <h3 className="text-white font-semibold text-sm mb-1 line-clamp-2">
                  {nativeAd.title}
                </h3>
                {nativeAd.description && (
                  <p className="text-gray-300 text-xs line-clamp-2">
                    {nativeAd.description}
                  </p>
                )}
              </div>
              
              <div className="flex-shrink-0">
                <span className="text-orange-400 text-xs font-medium">
                  Learn More →
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <style jsx>{`
        .line-clamp-2 {
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
        }
      `}</style>
    </div>
  );
};

export default NativeAdSection;